<template>
  <div>
    <!-- Page content -->
    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
      <form @submit.prevent="handleSubmit(sendForm)">
        <!-- Form buttons start -->
        <v-card-title style="color: #595959">
          <v-row>
            <v-col class="py-2 pl-0">{{ modalHeader }}</v-col>
            <v-spacer />
            <v-btn
              small
              type="submit"
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="info"
            >
              {{
                isUpdate
                  ? $t("labels.updateInnovation")
                  : $t("labels.addInnovation")
              }}
            </v-btn>
          </v-row>
        </v-card-title>
        <!-- Form buttons end -->

        <v-divider />

        <v-layout row wrap class="px-0 py-10">
          <v-flex xs12 md8>
            <!-- Privacy select start  -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.choosePrivacy") }}
                </v-card-title>

                <v-layout>
                  <v-col cols="12">
                    <v-layout class="mx-2">
                      <v-radio-group v-model="contentType" row color="red">
                        <v-radio
                          :label="$t('labels.anonim')"
                          :value="1"
                          color="purple"
                        ></v-radio>
                        <v-radio
                          :label="$t('labels.public')"
                          :value="2"
                          color="purple"
                        ></v-radio>
                      </v-radio-group>
                    </v-layout>
                  </v-col>
                </v-layout>
              </v-banner>
            </v-card-text>
            <!-- Privacy select end  -->

            <!-- Title  -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5 my-2">
                <ValidationProvider
                  :name="$t('labels.header')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :label="$t('labels.header')"
                    v-model="title"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.header") }}</v-card-title
                >
              </v-banner>
            </v-card-text>
            <!-- Title end -->

            <!-- İçerik Bölümü -->
            <v-card-text class="px-0 py-2">
              <ValidationProvider
                :name="$t('labels.description')"
                rules="required"
                v-slot="{ errors }"
              >
                <ckeditor
                  :name="$t('labels.description')"
                  :editor="editor"
                  v-model="editorData"
                  :config="editorConfig"
                ></ckeditor>
                <div class="error--text">{{ errors[0] }}</div>
              </ValidationProvider>

              <v-card-title
                class="add-content-title"
                style="font-size: 12px !important;"
                >{{ $t("labels.description") }}</v-card-title
              >
            </v-card-text>

            <!-- İçerik end -->
            <!-- Photo Upload -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title"
                  >Fotoğraf Yükle</v-card-title
                >
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                ></v-card-title>

                <v-row>
                  <v-col>
                    <input
                      type="file"
                      accept="image/*"
                      ref="uploader"
                      class="d-none"
                      @change="onFileChange"
                    />

                    <v-btn
                      small
                      class="ma-4 mr-8"
                      elevation="0"
                      outlined
                      color="info"
                      :disabled="photoLength == 1"
                      @click="browsePhoto()"
                    >
                      {{ $t("buttons.uploadNew") }}
                    </v-btn>
                    <!-- <v-btn
                      small
                      class="ma-4 mr-4"
                      elevation="0"
                      outlined
                      :disabled="photoLength == 1"
                      color="info"
                    >
                      {{ $t("buttons.uploadfromLibrary") }}
                    </v-btn> -->
                  </v-col>
                  <v-col
                    align-self="end"
                    class="mr-5"
                    style="text-align: end"
                    v-if="selectedPhotoModel"
                  >
                    {{ photoLength == null ? " " : photoLength + " /" + " 1" }}
                  </v-col>
                </v-row>

                <v-banner
                  rounded
                  outlined
                  class="mt-5"
                  v-if="selectedPhotoModel"
                >
                  <v-hover>
                    <v-img
                      style="border-radius: 8px"
                      max-height="250px"
                      :aspect-ratio="4 / 3"
                      contain
                      :src="
                        selectedPhotoModel.LocalUrl == null
                          ? computedUrl(selectedPhotoModel)
                          : selectedPhotoModel.LocalUrl
                      "
                      slot-scope="{ hover }"
                    >
                      <v-expand-transition>
                        <div
                          v-if="hover"
                          class="transition-fast-in-fast-out image-hover white--text"
                          style="height: 100%"
                        >
                          <v-layout
                            row
                            wrap
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  @click="deletePhoto(selectedPhotoModel, 0)"
                                  class="ma-0"
                                  icon
                                  v-on="on"
                                  style="z-index: 100"
                                >
                                  <v-icon color="white">mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("labels.deleteKey") }}</span>
                            </v-tooltip>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  class="ma-0"
                                  icon
                                  v-on="on"
                                  style="z-index: 100"
                                >
                                  <v-icon color="white">mdi-folder</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ selectedPhotoModel.name }}</span>
                            </v-tooltip>
                          </v-layout>
                        </div>
                      </v-expand-transition>
                    </v-img>
                  </v-hover>
                </v-banner>
              </v-banner>
            </v-card-text>
            <!-- Photo upload end -->
            <!-- Score Field start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5 my-2">
                <ValidationProvider
                  :name="$t('labels.Score')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :label="$t('labels.Score')"
                    v-model="score"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.Score") }}</v-card-title
                >
              </v-banner>
            </v-card-text>
            <!-- Score field  end -->
            <!-- Member Count Field start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5 my-2">
                <ValidationProvider
                  :name="$t('labels.maxMemberCount')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    :label="$t('labels.maxMemberCount')"
                    v-model="memberCount"
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.maxMemberCount") }}</v-card-title
                >
              </v-banner>
            </v-card-text>
            <!-- Member Count field  end -->
            <!-- Jury Field start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5 my-2">
                <ValidationProvider
                  :name="$t('labels.juries')"
                  rules="required"
                  v-slot="{ errors }"
                  class="d-lg-flex"
                >
                  <v-select
                    :items="adminUsers"
                    v-model="juries"
                    placeholder="Juriler"
                    class="custom-border"
                    item-value="Id"
                    item-text="Name"
                    multiple
                    variant="underlined"
                    append-icon="keyboard_arrow_down"
                    :error-messages="errors[0]"
                  ></v-select>
                </ValidationProvider>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.juries") }}</v-card-title
                >
              </v-banner>
            </v-card-text>
            <!-- Jury field  end -->
            <!-- Badges start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5 my-2">
                <ValidationProvider
                  :name="$t('labels.participationBadges')"
                  v-slot="{ errors }"
                  class="d-lg-flex"
                >
                  <v-select
                    :items="badges"
                    v-model="selectedBadges"
                    :placeholder="$t('labels.participationBadges')"
                    class="custom-border"
                    item-value="Id"
                    item-text="Name"
                    multiple
                    variant="underlined"
                    append-icon="keyboard_arrow_down"
                    :error-messages="errors[0]"
                  ></v-select>
                </ValidationProvider>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.participationBadges") }}</v-card-title
                >
              </v-banner>
            </v-card-text>
            <!-- Badges  end -->
            <!-- Tag start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.tags") }}
                </v-card-title>

                <v-col class="pt-0">
                  <v-combobox
                    v-model="tagName"
                    :items="tags"
                    :search-input.sync="search"
                    hide-selected
                    :hint="$t('labels.max15')"
                    :label="$t('labels.tags')"
                    multiple
                    :disabled="tagIds.length == 15"
                    persistent-hint
                    deletable-chips
                    small-chips
                    item-text="TagName"
                    item-value="Id"
                    @input="selectTag(tagName)"
                    @keyup.enter="addTag(tagName)"
                    counter="15"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            "<strong>{{ search }}</strong
                            >" için bir eşleşme bulunamadı. Yeni bir tane
                            oluşturmak için <kbd>enter</kbd> tuşuna basın.
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                  <v-alert
                    v-if="tagIds.length == 15"
                    border="left"
                    close-text="Close Alert"
                    type="info"
                    color="#7443a0"
                    dismissible
                    outlined
                    prominent
                    class="font-weight-black mt-3"
                    style="font-size: 1.2em"
                  >
                    {{ $t("description.tagCountReached") }}
                  </v-alert>
                </v-col>
              </v-banner>
            </v-card-text>
            <!-- Tag end -->
            <!-- Criterations start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.criteria") }}
                </v-card-title>

                <v-col class="pt-0">
                  <v-combobox
                    v-model="criterion"
                    :items="criteria"
                    :search-input.sync="search"
                    hide-selected
                    :hint="$t('labels.max15')"
                    :label="$t('labels.criteria')"
                    multiple
                    :disabled="criterionIds.length == 15"
                    persistent-hint
                    deletable-chips
                    small-chips
                    item-text="Name"
                    item-value="Id"
                    @input="selectCriterion(criterion)"
                    @keyup.enter="addCriterion(criterion)"
                    counter="15"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            "<strong>{{ search }}</strong
                            >" için bir eşleşme bulunamadı. Yeni bir tane
                            oluşturmak için <kbd>enter</kbd> tuşuna basın.
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                  <v-alert
                    v-if="criterionIds.length == 15"
                    border="left"
                    close-text="Close Alert"
                    type="info"
                    color="#7443a0"
                    dismissible
                    outlined
                    prominent
                    class="font-weight-black mt-3"
                    style="font-size: 1.2em"
                  >
                    Kriter siniri asildi.
                  </v-alert>
                </v-col>
              </v-banner>
            </v-card-text>
            <!-- Criterations end -->
            <!-- Date and time picker start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.endDate") }}
                </v-card-title>
                <v-card-title
                  class="add-content-title"
                  style="font-size: 12px !important;"
                  >{{ $t("labels.endDate") }}</v-card-title
                >
                <v-row align="center" justify="space-between" class="pr-5">
                  <v-col cols="5">
                    <v-text-field
                      v-model="dateValueDisplay"
                      :label="$t('labels.selectDate')"
                      readonly
                    >
                      <template v-slot:prepend>
                        <date-picker v-model="dateValue" />
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="timeValueDisplay"
                      :label="$t('labels.selectTime')"
                      readonly
                    >
                      <template v-slot:prepend>
                        <time-picker v-model="timeValue" />
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-banner>
            </v-card-text>
            <!-- Date and time picker end -->
          </v-flex>
          <v-flex md4>
            <!-- popup start -->
            <v-card-text class="px-0 py-0 add-content-card-body">
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{ $t("labels.popupChoose") }}
                </v-card-title>
                <v-row class="mx-2">
                  <v-col cols="12" sm="6" md="6">
                    <v-checkbox
                      v-model="checkboxPin"
                      :label="'Pop-up olarak göster.'"
                      hide-details
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-banner>
            </v-card-text>
            <!-- pop-up -->

            <!-- Category start  -->
            <v-card-text
              class="px-0 py-0 add-content-card-body"
              v-if="categoryData != null && categoryData.length > 0"
            >
              <v-banner rounded outlined class="mt-5">
                <v-card-title class="add-content-title">
                  {{
                    $t("labels.postCategory") +
                      $t("labels.postCategoryRequired")
                  }}
                </v-card-title>
                <v-treeview
                  v-model="selectedCategoriesModal"
                  :items="categoryData"
                  selection-type="leaf"
                  item-children="Children"
                  item-value="Id"
                  item-text="CategoryNameTR"
                  item-key="Id"
                  selectable
                  open-all
                  style="overflow: auto; height: 300px;"
                ></v-treeview>
              </v-banner>
            </v-card-text>
            <!-- Category end -->
          </v-flex>
        </v-layout>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import UserService from "../services/UserService";
import InnovationService from "../services/InnovationService";
import CriteriaService from "../services/CriterionService";
import DeleteModal from "../components/General/DeleteModal";
import FileService from "../services/FileService";
import CategoryService from "../services/CategoryService";
import TagService from "../services/TagService";
import BadgeService from "../services/BadgeService";
import { mapActions } from "vuex";

import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import Link from "@ckeditor/ckeditor5-link/src/link";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import List from "@ckeditor/ckeditor5-list/src/list.js";
import Heading from "@ckeditor/ckeditor5-heading/src/heading.js";
import Indent from "@ckeditor/ckeditor5-indent/src/indent.js";
import IndentBlock from "@ckeditor/ckeditor5-indent/src/indentblock";
import Font from "@ckeditor/ckeditor5-font/src/font";
export default {
  data: () => ({
    photoLength: null,
    adminUsers: null,
    selectedPhotoModel: null,
    selectedPhoto: [],
    fileControlArr: [],
    photoLength: null,
    selectedPhotoUrl: [],
    criterion: "",
    criteria: [],
    criterionIds: [],
    tagName: "",
    tags: [],
    fileIds: [],
    tempFiles: [],
    search: null,
    tagIds: [],
    editorData: "",
    score: 0,
    memberCount: 5,
    juries: [],
    badges: [],
    selectedBadges: [],
    checkboxPin: false,
    // List options
    options: {
      itemsPerPage: 15,
    },
    modalHeader: "Inovasyon Ekleme",
    //Group
    selecItems: [],
    fileErrorFlag: false,
    groupData: [],
    groupLengthAlert: false,
    groupArr: [[]],
    groupsSelectArray: [],
    corpGroup: [],
    locGroup: [],
    contentType: 0,
    empGroup: [],
    allSelect: [],
    selectedCategoriesModal: [],
    cData: null,
    categoryData: [],
    requiredCategoryLength: -1,
    categoryIds: [
      {
        id: "6491b383f6269cce08f4bcc1",
        _comment: "(parent kategori id)",
        isRequired: true,
      },
    ],
    isUpdate: false,
    groupModel: {
      Groups: [],
    },

    editor: ClassicEditor,
    editorConfig: {
      plugins: [
        Essentials,
        Bold,
        Italic,
        Link,
        Paragraph,
        List,
        Heading,
        Indent,
        IndentBlock,
        Font,
      ],

      toolbar: {
        items: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "|",
          "outdent",
          "indent",
          "|",
          "undo",
          "redo",
          "|",
          "fontSize",
          "fontColor",
          "fontBackgroundColor",
        ],
      },
      fontSize: {
        options: [9, 11, 13, 15, 17, 19, 21, 23, 25, 27, 29],
      },
    },

    //Pagination models
    pagination: {},
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],

    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),

    dateValue: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    timeValue: "",
    //Form
    title: "",
    description: "",
    createdBy: null,
  }),

  watch: {},
  mounted() {
    this.getCategoriesInTreeView();
    this.getBadges();
    this.getAdminUsers();
    this.getTags();
    this.getCriterion();
  },
  components: {
    DeleteModal,
    DatePicker: () => import("../components/General/DatePicker.vue"),
    TimePicker: () => import("../components/General/TimePicker.vue"),
  },

  computed: {
    dateValueDisplay() {
      return convertToLocal(this.dateValue);
    },
    timeValueDisplay() {
      return this.timeValue;
    },
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  methods: {
    getAdminUsers() {
      this.$store.state.loadingStatus = true;
      this.adminUsers = [];
      UserService.getUsersByType("Admin", 1000, 1)
        .then((res) => {
          // Yeni dizi oluşturma
          this.adminUsers = res.data.Data.map(function(user) {
            return {
              Name: user.FullName,
              Id: user.Id,
            };
          });
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getBadges() {
      this.$store.state.loadingStatus = true;
      this.badges = [];
      BadgeService.getBadges(1, 100, 1)
        .then((res) => {
          // Yeni dizi oluşturma
          this.badges = res.data.Result.map(function(badge) {
            return {
              Name: badge.Name,
              Id: badge.Id,
            };
          });
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getInnovationDetail(id) {
      this.$store.state.loadingStatus = true;
      this.isUpdate = true;
      InnovationService.getInnovations(1, 1, id)
        .then((res) => {
          // Yeni dizi oluşturma
          this.checkboxPin = res.data.Result[0].IsFile;
          this.dateValue = res.data.Result[0].EndDate.substring(
            0,
            res.data.Result[0].EndDate.indexOf("T")
          );
          this.timeValue = res.data.Result[0].EndDate.substring(
            res.data.Result[0].EndDate.indexOf("T") + 1,
            res.data.Result[0].EndDate.indexOf("Z")
          );
          this.title = res.data.Result[0].Title;
          this.editorData = res.data.Result[0].Description;
          this.contentType = res.data.Result[0].IsPrimacy == true ? 1 : 2;
          this.fileIds = res.data.Result[0].FileIds;
          this.selectedCategoriesModal = res.data.Result[0].Categories;
          this.tagName = res.data.Result[0].Tags;
          this.score = res.data.Result[0].Score;
          this.memberCount = res.data.Result[0].MaxMemberCount;
          this.criterion = res.data.Result[0].Criterions;
          this.selectedBadges = res.data.Result[0].ParticipationBadges;
          this.juries = res.data.Result[0].Juries;
          this.selectedPhotoModel = res.data.Result[0].Files.find(
            (x) => x.Id == res.data.Result[0].FileIds[0]
          );
          if (this.selectedPhotoModel) {
            this.fileControlArr.unshift("photo");
          }
          if (this.selectedPhotoModel) {
            this.photoLength = 1;
          }
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
      this.modalHeader = "Inovasyon Güncelleme";
    },
    onFileChange(e) {
      if (e.target.files[0] === undefined) {
      } else {
        if (e.target.files[0].size < 1000000) {
          this.selectedPhotoModel = e.target.files[0];
          this.uploadPhoto(this.selectedPhotoModel);
        } else {
          window.showInfo(
            this.$t("description.fileSizeError"),
            "standart",
            "error"
          );
        }
      }
      e.target.value = "";
    },
    deletePhoto(photo, index) {
      this.selectedPhoto.splice(index, 1);
      this.selectedPhotoUrl.splice(index, 1);
      this.tempFiles.splice(index, 1);

      this.fileControlArr.splice(index, 1);
      this.selectedPhoto = [];
      this.selectedPhotoUrl = [];
      this.selectedPhotoModel = null;

      this.photoLength--;
      this.fileIds.splice(index, 1);
    },
    computedUrl(file) {
      return URL.createObjectURL(file);
    },
    //Photo upload to service
    uploadPhoto(media) {
      if (media === undefined) {
        console.log("Undefined media");
      } else {
        if (media.size > 1000000) {
          window.showInfo(
            this.$t("description.fileSizeError"),
            "standart",
            "error"
          );
        } else {
          this.selectedPhoto.push(media);
          this.tempFiles.unshift(media);
          this.fileControlArr.unshift("photo");
          this.selectedPhotoUrl.push(this.computedUrl(media));
          this.photoLength = 1;
        }
      }
    },
    async uploadFiles(index) {
      if (index < this.tempFiles.length) {
        this.uploadFileCall(this.tempFiles[index], index);
      } else {
        this.publishCall();
      }
    },
    async uploadFileCall(media, index) {
      if (media === undefined) {
        console.log("Undefined media");
      }
      let formData = new FormData();
      if (
        media.type == "image/jpeg" ||
        media.type == "image/png" ||
        media.type == "video/mp4"
      ) {
        formData.append("Files", media);
        formData.append("Type", "media");
      } else {
        formData.append("Files", media);
        formData.append("Type", "document");
      }
      console.log("Form data >> ", formData);
      await Promise.resolve(
        FileService.uploadFile(formData)
          .then((res) => {
            this.fileIds.push(res.data[0].Id);
          })
          .catch((err) => {
            this.fileErrorFlag = true;
            window.showError(err);
          })
          .then(() => {
            this.uploadFiles(index + 1);
          })
      );
    },
    async publish() {
      this.$store.state.loadingStatus = true;
      if (this.photoLength != 1) {
        window.showInfo(
          this.$t("description.contentPhotoUpload"),
          "standart",
          "info"
        );
        this.$store.state.loadingStatus = false;
      } else {
        if (this.tempFiles.length > 0) {
          let control = await this.uploadControl();
          if (control) {
            await this.uploadFiles(0);
          } else {
            window.showInfo(
              this.$t("description.errorOnCreate"),
              "standart",
              "info"
            );
            this.$store.state.loadingStatus = false;
          }
        } else if (!this.isRequiredPhoto || !this.isRequiredForAdvancement) {
          this.publishCall();
        } else {
          window.showInfo(
            this.$t("description.contentPhotoUpload"),
            "standart",
            "info"
          );
          this.$store.state.loadingStatus = false;
        }
      }
    },
    //Add tag to service
    addTag(tag) {
      if (this.tagIds.length <= 15) {
        tag.forEach((x, index) => {
          if (x.Id == undefined) {
            let body = {
              TagName: x,
            };
            if (index == tag.length - 1) {
              this.$store.state.loadingStatus = true;
              TagService.createTags(body)
                .then((res) => {
                  //this.tags=  res.data
                  this.tags[index] = res.data;
                  this.tagIds.push(res.data.Id);
                })
                .catch((err) => {
                  window.showError(err);
                })
                .then(() => {
                  this.$store.state.loadingStatus = false;
                });
            }
          }
        });
        this.tagIds = this.tagIds.filter((x) => x != undefined);
        this.tagIds = [...new Set(this.tagIds)];
      }
    },
    //Delete tag
    deleteTag(tag) {
      if (this.tagIds.length == 15) {
      }
      this.tags.delete(tag);
      this.myTagSetChangeTracker -= 1;
      this.tagIds.length--;
      console.log("ids", this.tagIds);
      console.log("tags", this.tags);
      console.log("names", this.tagName);
    },
    //Choose tag to add content
    selectTag(tag) {
      if (tag && this.tagIds.length <= 15 && tag.length <= 15) {
        // this.tagIds = [];
        tag.forEach((x) => this.tagIds.push(x.Id));
      }
      this.tagIds = [...new Set(this.tagIds)];
      this.tagIds = this.tagIds.filter((x) => x != undefined);
    },
    getTags() {
      this.$store.state.loadingStatus = true;
      TagService.getTags()
        .then((res) => {
          this.tags = res.data;
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getCriterion() {
      this.$store.state.loadingStatus = true;
      CriteriaService.getCriteria()
        .then((res) => {
          this.criteria = res.data;
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
          this.setup();
        });
    },
    addCriterion(criterion) {
      if (this.criterionIds.length <= 15) {
        console.log("criterr", criterion);
        criterion.forEach((x, index) => {
          if (x.Id == undefined) {
            let body = {
              Name: x,
            };
            if (index == criterion.length - 1) {
              this.$store.state.loadingStatus = true;
              CriteriaService.createCriterion(body)
                .then((res) => {
                  console.log("res", res.data);
                  //this.tags=  res.data
                  this.criterion[index] = res.data;
                  this.criterionIds.push(res.data.Id);
                })
                .catch((err) => {
                  window.showError(err);
                })
                .then(() => {
                  this.$store.state.loadingStatus = false;
                });
            }
          }
        });
        this.criterionIds = this.criterionIds.filter((x) => x != undefined);
        this.criterionIds = [...new Set(this.criterionIds)];
      }
    },
    //Delete tag
    deleteCriterion(criterion) {
      if (this.criterionIds.length == 15) {
      }
      this.criteria.delete(criterion);
      this.myTagSetChangeTracker -= 1;
      this.criterionIds.length--;
    },
    //Choose tag to add content
    selectCriterion(criterion) {
      if (criterion && this.criterionIds.length <= 15) {
        criterion.forEach((x) => this.criterionIds.push(x));
      }
      this.criterionIds = [...new Set(this.criterionIds)];
      this.criterionIds = this.criterionIds.filter((x) => x != undefined);
    },
    getCategoriesInTreeView() {
      if (this.categoryIds.length > 0) {
        this.$store.state.loadingStatus = true;
        this.categoryIds.forEach((element, index) => {
          CategoryService.getCategoriesInTreeView(element.id)
            .then((res) => {
              this.categoryData = this.categoryData.concat(res.data);

              // this.categoryData = { ...this.categoryData, ...res.data };
            })
            .catch((err) => {
              window.showError(err);
            })
            .then(() => {
              this.categoryData.forEach((element, index) => {
                this.categoryData[index].IsRequired = this.categoryIds[
                  index
                ].isRequired;
              });
              let reqArray = this.categoryData.filter((x) => x.IsRequired)
                .length;
              this.requiredCategoryLength = reqArray;
              this.$store.state.loadingStatus = false;
            });
        });
      }
    },
    sendForm() {
      this.publish();
    },
    setup() {
      this.$route.query.id != null
        ? this.getInnovationDetail(this.$route.query.id)
        : null;
    },
    browsePhoto() {
      this.$refs.uploader.click();
    },
    async publishCall() {
      this.tagIds = [];
      this.criterionIds = [];
      // Type: this.flag ? "individual" : "corporate", this.pageRules.isPublicGroups ? "individual" : "corporate",
      this.tagName.forEach((element) => {
        this.tagIds.push(element.Id);
      });
      this.criterion.forEach((element) => {
        this.criterionIds.push(element);
      });
      let body = {
        EndDate: this.dateValue + " " + this.timeValue,
        Title: this.title,
        Description: this.editorData,
        IsPrimacy: this.contentType == 1 ? true : false,
        FileIds: this.fileIds,
        Categories: this.selectedCategoriesModal,
        TagIds: this.tagIds,
        IsFile: this.checkboxPin,
        Score: this.score,
        MaxMemberCount: this.memberCount,
        Criterions: this.criterionIds,
        ParticipationBadges: this.selectedBadges,
        Juries: this.juries,
      };
      let control = await this.uploadControl();
      console.log("body", body);
      if (control && !this.fileErrorFlag) {
        if (!this.isUpdate) {
          this.$store.state.loadingStatus = true;
          InnovationService.createInnovation(body)
            .then((res) => {
              this.$store.state.loadingStatus = false;
              this.$router.push({ name: "innovation" });
            })
            .catch((err) => {
              this.$store.state.loadingStatus = false;
              window.showError(err);
            })
            .then(() => {
              this.$store.state.loadingStatus = false;
            });
        } else {
          body.Id = this.$route.query.id;
          this.$store.state.loadingStatus = true;
          InnovationService.updateInnovation(body)
            .then((res) => {
              this.$store.state.loadingStatus = false;
              this.$router.push({ name: "innovation" });
            })
            .catch((err) => {
              this.$store.state.loadingStatus = false;
              window.showError(err);
            })
            .then(() => {
              this.$store.state.loadingStatus = false;
            });
        }
      } else {
        if (this.fileErrorFlag) {
          window.showInfo(
            this.$t("description.errorOnCreateContent"),
            "standart",
            "info"
          );
        } else {
          window.showInfo(
            this.$t("description.errorOnCreate"),
            "standart",
            "info"
          );
        }
        this.fileErrorFlag = false;
        this.$store.state.loadingStatus = false;
      }
    },
    async uploadControl() {
      if (!this.fileControlArr.includes("photo")) {
        return false;
      }

      //Custom Field control
      if (
        this.pageKey == "aramiza_katilanlar" ||
        this.pageKey == "yeni_doganlar"
      ) {
        let tempArr = this.properties.filter((x) => x.Key == "sicilNumber");
        if (tempArr[0].Value == "" || tempArr[0].Value == "00000000") {
          window.showInfo(
            this.$t("description.propertyEmptySicil"),
            "standart",
            "info"
          );
          return false;
        }
      }
      //Custom Field control this.isRequiredLink

      if (
        this.categoryData.length > 0 &&
        this.selectedCategoriesModal.length < 1
      ) {
        window.showInfo(
          this.$t("description.emptyCategorySelect"),
          "standart",
          "info"
        );
        return false;
      }
      if (this.selectedCategoriesModal.length > 0) {
        let index = 0;
        this.selectedCategoriesModal.forEach((i) => {
          this.categoryData.forEach((element) => {
            var result = this.searchTree(element, i, false);
            if (result) {
              index++;
            }
          });
        });
        if (index < this.requiredCategoryLength) {
          window.showInfo(
            this.$t("description.emptyCategorySelect"),
            "standart",
            "info"
          );
          return false;
        }
      }

      return true;
    },

    //Loads groups when page loaded

    searchTree(element, id) {
      if (element.Id == id) {
        return element;
      } else if (element.Children != null) {
        var result = null;
        element.Children.forEach((child) => {
          if (result == null) {
            result = this.searchTree(child, id);
          }
        });
        return result;
      }
      return null;
    },
    createNewGroup() {
      if (this.groupsSelectArray.length < 4) {
        this.groupLengthAlert = false;
        let arr = [];
        this.groupData.forEach((element) => {
          let obj = {
            type: element.type,
            groups: [],
            name: element.name,
          };

          arr.push(obj);
        });

        this.groupsSelectArray = [...this.groupsSelectArray, arr];
        this.groupArr.push([]);
      } else {
        this.groupLengthAlert = true;
      }
    },
    //Delete Group Line
    deleteGroupRow(rowIndex) {
      if (!(this.groupsSelectArray.length == 1)) {
        if (this.groupsSelectArray.length == 4) {
          this.groupLengthAlert = false;
        }

        this.groupsSelectArray.splice(rowIndex, 1);
        this.groupArr.splice(rowIndex, 1);
      } else {
        window.showInfo(
          this.$t("description.groupRowDelete"),
          "standart",
          "info"
        );
      }
    },
    //Change corparate group
    changeGroupInput(element, colIndex, dataIndex) {
      if (element.type == "sirket") {
        this.groupArr[dataIndex][colIndex + 1] = "";
      }
    },
    // Fill select box items

    //Group types
  },
};
</script>
